import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import Api from '../../../../_helpers/Api'
import { useAuthDataContext } from '../../../../_providers/Auth'

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import loader from '../../../../assets/img/loader.svg'
import { trans } from '../../../../_providers/Translation'

function Transfer(props, ref) {

    const auth = useAuthDataContext()

    const partnerId = auth.data.user.partner_id

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        id: null,
        data: null,
        loading: false,
        update: false,
    })

    const [vans, setVans] = useState({
        loading: true,
        data: [],
    })

    const [storages, setStorages] = useState({
        loading: true,
        data: [],
    })

    const [validations, setValidations] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)

    useImperativeHandle(ref, () => ({
        show: (id) => {
            setPopup(prev => ({
                ...prev,
                id: id,
                loading: false,
                update: Math.random().toString()
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    // извлича текущите данни, за да се попълнят полетата
    useEffect(() => {

        if (popup.id) {
            Api.get(`storage/find-part?id=${popup.id}`)
                .then(res => {

                    let data = res.data

                    data.max_quantity = data.quantity

                    setPopup(prev => ({
                        ...prev,
                        data: data,
                    }))
                })
        }

    }, [popup.update])

    useEffect(() => {
        loadVans()
        loadStorages()
    }, [])

    const loadVans = () => {
        let url = 'vans/all?paginate=0'

        Api.get(url)

            .then(res => {
                setVans(prev => ({
                    ...prev,
                    loading: false,
                    data: Array.isArray(res.data) ? res.data : (res.data?.data || []),
                }))
            }).catch(err => {
                setVans(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const loadStorages = () => {
        Api.get('storages/all')
            .then(res => {
                setStorages(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data,
                }))
            }).catch(err => {
                setStorages(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()


        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)
        setErrorMessage(null)

        let url = 'storage/transfer-part'

        let data = new FormData(e.target)

        data.append('id', popup.id)

        Api.post(url, data)
            .then(res => {

                props.handleRefresh()

                handleHide(e)

                document.getElementById("form").reset()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    if (_err.data?.message) {
                        setErrorMessage(_err.data.message)
                    }
                    if (_err.data?.errors) {
                        for (let [input] of Object.entries(_err.data.errors)) {
                            setValidations(prevState => ({ ...prevState, [input]: true }))
                        }
                    }
                }

            })
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = Number(e.target.value)

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form className={`${popup.modal ? 'show' : ''} popup-primary large`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="head" />
                    <div className='texts'>
                        <h2>
                            {popup?.data?.type === 'appliance'
                                ? trans('headings.transferAppliance')
                                : popup?.data?.type === 'part'
                                ? trans('headings.transferPart')
                                : ''}
                        </h2>
                        <p>
                            Lorem Ipsum е елементарен примерен текст, използван
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <div className="popup-container x2">
                    <div className="col">
                        <label>
                            {trans('labels.part')}
                        </label>
                        <input
                            type="text"
                            value={popup.data && popup.data.name ? popup.data.name : ''}
                            disabled={true}
                        />
                    </div>

                    <div className="col">
                        <label>
                            {trans('labels.partNumber')}
                        </label>
                        <input
                            type="text"
                            value={popup.data && popup.data && popup.data.number ? popup.data.number : ''}
                            disabled={true}
                        />
                    </div>

                </div>

                <br />

                <div className="popup-container x2">
                    <div className="col">
                        <label>
                            {trans('labels.quantity')}
                        </label>
                        <input
                            id="quantity"
                            type="number"
                            min="1"
                            max={popup.data && popup.data.max_quantity}
                            step="1"
                            name="quantity"
                            value={popup.data && popup.data.quantity ? popup.data.quantity : 1}
                            className={validations && validations.quantity ? 'validate' : ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="col">
                        <label>
                            {trans('labels.transferFrom')}
                        </label>
                        <select
                            name="from_storage_location_id"
                            className={validations && validations.from_storage_location_id ? 'validate' : ''}
                        >
                            {/* Warehouses */}
                            {storages.data.map(s => (
                                <option key={'storage-' + s.id} value={s.id}>{s.name}</option>
                            ))}
                            {/* Vans */}
                            {vans.data.map(v => (
                                v.storage_location ? (
                                    <option key={'van-' + v.id} value={v.storage_location.id}>{v.reg_no} {v.employee && `(${v.employee.name})`}</option>
                                ) : null
                            ))}
                        </select>
                    </div>
                </div>

                <br />

                <div className="popup-container x2">
                    <div className="col">
                        <label>
                            {trans('labels.transferTo')}
                        </label>
                        <select
                            name="storage_location_id"
                            className={validations && validations.storage_location_id ? 'validate' : ''}
                        >
                            {/* Warehouses */}
                            {storages.data.map(s => (
                                <option key={'storage-' + s.id} value={s.id}>{s.name}</option>
                            ))}
                            {/* Vans */}
                            {vans.data.map(v => (
                                v.storage_location ? (
                                    <option key={'van-' + v.id} value={v.storage_location.id}>{v.reg_no} {v.employee && `(${v.employee.name})`}</option>
                                ) : null
                            ))}
                        </select>
                    </div>
                </div>

                {errorMessage && (
                    <div className="alert danger" style={{ margin: '0 15px 10px' }}>
                        {errorMessage}
                    </div>
                )}

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(Transfer)